import { testimonials } from "@/mocks/naruto";

const FEATURES = [
  {
    icon: "ri-database-2-line",
    title: "全网最全",
    desc: "聚合海量火影同人作品，五大题材分类齐全，热门与冷门佳作都找得到。",
  },
  {
    icon: "ri-flashlight-fill",
    title: "更新及时",
    desc: "热门连载每日更新，最新章节实时推送，追更不迷路、不错过。",
  },
  {
    icon: "ri-user-heart-line",
    title: "氛围友好",
    desc: "活跃的读者与创作者社区，评论区氛围良好，共同守护火影情怀。",
  },
  {
    icon: "ri-verified-badge-line",
    title: "免费畅读",
    desc: "海量作品免费在线阅读，新用户注册即领限时免费阅读券。",
  },
];

export default function Reputation() {
  return (
    <section id="reputation" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 md:gap-12">
          {/* 左侧：品牌介绍 */}
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-bold text-primary-600">
              <i className="ri-heart-3-fill"></i> 关于我们
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-900 md:text-4xl">
              一起守护属于火影粉丝的乐园
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              火影同人动漫是一个由资深火影粉丝共同打造的内容聚合站。我们坚信，火影的世界不该只停留在原作，
              每一个热爱它的粉丝都值得拥有更广阔的故事。因此，我们汇聚了来自创作者的优质同人作品，
              用清晰的分类与稳定的更新，陪伴每一位读者的追更旅程。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们的发展理念很简单：尊重原创、扶持创作、重视每一位读者的体验。无论你是寻找热血战斗、
              穿越重生，还是只想静静重温木叶的温暖日常，这里都有属于你的那一部作品。
            </p>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {FEATURES.map((f) => (
                <div key={f.title} className="flex gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-500/10 text-xl text-primary-600">
                    <i className={f.icon}></i>
                  </span>
                  <div>
                    <h3 className="text-sm font-bold text-foreground-900">{f.title}</h3>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 右侧：用户口碑 */}
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-bold text-accent-600">
              <i className="ri-chat-quote-fill"></i> 用户口碑
            </span>
            <h3 className="mt-2 font-heading text-xl font-black text-foreground-900 md:text-2xl">
              听听追更伙伴怎么说
            </h3>

            <div className="mt-6 grid grid-cols-1 gap-4">
              {testimonials.map((t) => (
                <figure key={t.name} className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <div className="flex items-center gap-1 text-accent-500">
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </div>
                  <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                    “{t.text}”
                  </blockquote>
                  <figcaption className="mt-4 flex items-center gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 font-heading font-black text-background-50">
                      {t.avatar}
                    </span>
                    <div>
                      <p className="text-sm font-bold text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}